import { render, staticRenderFns } from "./TableCategoryCustomers.vue?vue&type=template&id=4e274198"
import script from "./TableCategoryCustomers.vue?vue&type=script&lang=js"
export * from "./TableCategoryCustomers.vue?vue&type=script&lang=js"
import style0 from "./TableCategoryCustomers.vue?vue&type=style&index=0&id=4e274198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports